import { FC } from "react";
import CustomPopup from "../../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import {
    UserResetPasswordFirstStep,
    UserResetPasswordSecondStep,
    UserResetPasswordThirdStep,
} from "../../../../domain/models/dto/UserDTO";
import CustomError from "../../../../custom-components/form-inputs/CustomError";
import { userResetPasswordThirdStepFields } from "../../../../validation-schemas/user-schemas/UserResetPasswordSchema";
import PasswordInput from "../../../resources/components/form-inputs/PasswordInput";

interface ResetPasswordThirdStepProps {
    error: string;
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
    firstStepForm: FormikProps<UserResetPasswordFirstStep>;
    secondStepForm: FormikProps<UserResetPasswordSecondStep>;
    thirdStepForm: FormikProps<UserResetPasswordThirdStep>;
}

const ResetPasswordThirdStep: FC<ResetPasswordThirdStepProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setIsVisible}
            wrapClassName="dmin2:min-w-[1062px] di6:min-w-[800px] ti6:min-w-[650px] ti7:min-w-[362px] tmax4:min-w-[362px]"
            title={t("resetPassword.resettingProcedure")}
            titleClassName="my-8 dmax2:my-6"
            confirmTitle={t("common.next")}
            confirmHandler={props.thirdStepForm.handleSubmit}
            confirmButtonClassName="w-[193px] dmax2:w-[133px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
        >
            <div className="relative flex flex-col items-center justify-center w-[410px] dmax2:w-[330px]">
                <p className="H20 dmax2:H16 text-textFaded text-center mb-6 dmax2:mb-5">
                    {t("resetPassword.resetThirdStepRule")}
                </p>
                <div className="relative w-full">
                    <PasswordInput
                        form={props.thirdStepForm}
                        name="password"
                        fields={userResetPasswordThirdStepFields}
                    />
                </div>
                <div className="relative w-full">
                    <PasswordInput
                        form={props.thirdStepForm}
                        name="confirmPassword"
                        fields={userResetPasswordThirdStepFields}
                    />
                </div>
                <CustomError
                    form={props.thirdStepForm}
                    errorKey={props.error}
                    className="mt-5 dmax2:mt-4 text-center"
                />
            </div>
        </CustomPopup>
    );
};

export default ResetPasswordThirdStep;
